const storageName = "yogaPersistentState"

export function saveToLocalStorage(state: Object) {
    try {
        const serialisedState = JSON.stringify(state);
        localStorage.setItem(storageName, serialisedState);
    } catch (e) {
        console.warn(e);
    }
}

export function loadFromLocalStorage() {
    try {
        const serialisedState = localStorage.getItem(storageName);
        if (serialisedState === null) return undefined;
        return JSON.parse(serialisedState);
    } catch (e) {
        console.warn(e);
        return undefined;
    }
}
